module.exports = __webpack_public_path__ + "static/media/bo.ca05d6f0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bo.svg
// module id = 2051
// module chunks = 0